import client from "./client";

// ترجمة نص قصير أو عنوان بين العربية والإنجليزية (mode: "name" | "address") — تُعيد "" عند الفشل.
export const translateText = async (text, target, mode = "name") => {
  try {
    const { data } = await client.post("/ai/translate", { text, target, mode });
    return data?.text || "";
  } catch {
    return "";
  }
};
